import { useTranslations } from '@vocab/react';
import { Box, Heading, Stack, Text } from 'braid-design-system';
import React from 'react';

import type { ApplyContext } from '../../../../../types';

import translations from './.vocab';

interface Props {
  applyContext: ApplyContext | null;
}

const JobApplyNudge = ({ applyContext }: Props) => {
  const { t } = useTranslations(translations);

  return applyContext ? (
    <Box
      paddingX={{ mobile: 'gutter', tablet: 'none' }}
      paddingTop={{ mobile: 'small', tablet: 'none' }}
      paddingBottom={{ mobile: 'medium', tablet: 'large' }}
    >
      <Stack space="medium">
        <Text tone="secondary" size="small">
          {t('Applying for')}
        </Text>
        <Stack space="small">
          <Heading level="2">{applyContext.title}</Heading>
          <Text>{applyContext.advertiser}</Text>
        </Stack>
      </Stack>
    </Box>
  ) : null;
};

export default JobApplyNudge;
